export default __webpack_public_path__ + "static/media/fightersword.669e1f0a.mp3";